import { render, staticRenderFns } from "./OtpModal.vue?vue&type=template&id=438d5017&scoped=true"
import script from "./OtpModal.vue?vue&type=script&lang=js"
export * from "./OtpModal.vue?vue&type=script&lang=js"
import style0 from "./OtpModal.vue?vue&type=style&index=0&id=438d5017&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438d5017",
  null
  
)

export default component.exports